import { LucideIcon, TrendingUp, Shield, Compass } from 'lucide-react'

export interface Differential {
    id: string
    title: string
    description: string
    icon: LucideIcon
}

export const differentials: Differential[] = [
    {
        id: 'transformacao-ti',
        title: 'TI como Parceiro de Negócio',
        description: 'Transformamos sua TI de um centro de custo em um parceiro estratégico.',
        icon: TrendingUp,
    },
    {
        id: 'trajetorias-claras',
        title: 'Trajetórias Claras',
        description: 'Convertemos processos confusos em arquiteturas robustas e objetivos alcançáveis.',
        icon: Compass,
    },
    {
        id: 'lgpd',
        title: 'Conformidade LGPD',
        description: 'Garantimos total aderência à Lei Geral de Proteção de Dados.',
        icon: Shield,
    },
]
